import { render, staticRenderFns } from "./FilterType.vue?vue&type=template&id=124cf710&"
import script from "./FilterType.vue?vue&type=script&lang=js&"
export * from "./FilterType.vue?vue&type=script&lang=js&"
import style0 from "../styles/filter-type.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports